import { configureStore } from "@reduxjs/toolkit";
import { thunk } from "redux-thunk";
import Auth from "./auth/slice";
import Home from "./home/slice";
import FileSlice from "./file/slice";
import MediaSlice from "./media/slice";
import ModalSlice from "./modal/slice";
import Pagination from "./pagination/slice";
import News from "./news/slice";
import About from "./about/slice";
import Partner from "./partner/slice";
import Branch from "./branch/slice";
import Services from "./services/slice";
import HeatingCalculation from "./heating-calculation/slice";
import SpecialOffers from "./special-offers/slice";
import FinancialReport from "./financial-report/slice";
import WeAreAvailable from "./we-are-available/slice";
import BecomePartner from "./become-partner/slice";
import SubscribeNews from "./subscribe-news/slice";
import Contact from "./contact/slice";
import UsefulTips from "./useful-tips/slice";
import Categories from "./categories/slice";
import Products from "./products/slice";
import Orders from "./orders/slice";
import Stories from "./stories/slice";
import DeliveryFee from "./delivery-fee/slice";
import InstallmentConditions from "./installment-conditions/slice";

export const store = configureStore({
  reducer: {
    home: Home.reducer,
    auth: Auth.reducer,
    news: News.reducer,
    about: About.reducer,
    partner: Partner.reducer,
    branch: Branch.reducer,
    heatingCalculations: HeatingCalculation.reducer,
    services: Services.reducer,
    categories: Categories.reducer,
    products: Products.reducer,
    orders: Orders.reducer,
    specialOffers: SpecialOffers.reducer,
    financialReport: FinancialReport.reducer,
    weAreAvailable: WeAreAvailable.reducer,
    becomePartner: BecomePartner.reducer,
    subscribeNews: SubscribeNews.reducer,
    contact: Contact.reducer,
    media: MediaSlice.reducer,
    file: FileSlice.reducer,
    modal: ModalSlice.reducer,
    pagination: Pagination.reducer,
    usefulTips: UsefulTips.reducer,
    stories: Stories.reducer,
    deliveryFee: DeliveryFee.reducer,
    installment_conditions: InstallmentConditions.reducer,
  },

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).concat(thunk),
  devTools: process.env.REACT_APP_ENV !== "dev",
});
